import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  medicalItems: [],
  allMedicalItems: [],
  totalPages: 0,
  totalRecords: 0,
  medicalItem: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_45: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_MedicalItems(state, medicalItems) {
    state.medicalItems = medicalItems.items;
    state.totalPages = medicalItems.totalPages;
    state.totalRecords = medicalItems?.totalRecords ?? 0;
  },
  SET_AllMedicalItems(state, medicalItems) {
    state.allMedicalItems = medicalItems;
  },
  SET_MedicalItem(state, medicalItem) {
    state.medicalItem = medicalItem;
  },
};
const actions = {
  errorMedicalItem({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllMedicalItems({ commit, dispatch, rootState }) {
    return apiClient
      .get('/MedicalItems/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllMedicalItems', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMedicalItem', error);
      });
  },
  getMedicalItemsWithPagination({ commit, dispatch, rootState }, { pageNumber, pageSize, title }) {
    var url = '/MedicalItems/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (title) {
      url += '&Title=' + title;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_MedicalItems', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMedicalItem', error);
      });
  },
  addMedicalItem({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/MedicalItems', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMedicalItem', error);
      });
  },
  getMedicalItem({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/MedicalItems/ById?medicalItemId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_MedicalItem', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMedicalItem', error);
      });
  },
  editMedicalItem({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/MedicalItems/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMedicalItem', error);
      });
  },
  deleteMedicalItem({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/MedicalItems/Remove?medicalItemId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMedicalItem', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
